export default __webpack_public_path__ + "static/media/loading.8ab7f444.gif";